import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { api } from "@/lib/api";

export default function PricingPreview() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(({ data }) => setServices(data)); }, []);

  return (
    <section data-testid="pricing-preview" className="bg-white">
      <div className="container-rv py-24 lg:py-32">
        <Reveal className="mb-14 text-center">
          <p className="overline text-brand-red">Simple, honest pricing</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-4xl font-bold text-brand-charcoal sm:text-5xl">
            Affordable luxury, right in your driveway
          </h2>
        </Reveal>

        <div className="grid gap-7 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1}>
              <div
                data-testid={`pricing-card-${s.id}`}
                className={`card-rv relative flex h-full flex-col p-8 hover:-translate-y-1.5 ${
                  s.popular
                    ? "border-brand-red/60 shadow-[0_30px_70px_-40px_rgba(200,16,46,0.45)] lg:-translate-y-4"
                    : "hover:shadow-[0_24px_60px_-40px_rgba(26,28,30,0.45)]"
                }`}
              >
                {s.popular && (
                  <span className="absolute -top-3 left-8 rounded-full bg-brand-red px-3 py-1 text-[0.65rem] font-semibold uppercase tracking-wider text-white">
                    Most Popular
                  </span>
                )}
                <h3 className="font-serif text-2xl font-bold text-brand-charcoal">{s.name}</h3>
                <p className="mt-1 text-sm text-brand-muted">{s.tagline}</p>
                <div className="mt-6 flex items-baseline gap-1">
                  {s.from && <span className="text-sm font-medium text-brand-muted">from</span>}
                  <span className="font-serif text-5xl font-bold text-brand-charcoal">${s.price}</span>
                </div>
                <div className="my-6 silver-divider" />
                <ul className="flex-1 space-y-3">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-brand-charcoal/85">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" /> {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/book?service=${s.id}`}
                  data-testid={`pricing-book-${s.id}`}
                  className={`mt-8 ${s.popular ? "btn-red" : "btn-outline-dark"} w-full`}
                >
                  Choose {s.name.split(" ")[0]} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 text-center">
          <Link to="/pricing" className="text-sm font-semibold text-brand-red hover:underline underline-offset-4">
            See full pricing & add-ons →
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
